import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function cardBody(theme: Theme): ComponentStyle {
  return {
    componentName: 'cardBody',
    variants: {
      table: {
        padding: `0 ${theme.space.xs} ${theme.space.m}`
      }
    }
  };
}
